module.exports = __webpack_public_path__ + "img/i-assistant.f89b519f.png";